/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ApiResourceType = {
  UNKNOWN_RESOURCE_TYPE: 'UNKNOWN_RESOURCE_TYPE',
  EXPERIMENT: 'EXPERIMENT',
  JOB: 'JOB',
  PIPELINE: 'PIPELINE',
  PIPELINE_VERSION: 'PIPELINE_VERSION',
  NAMESPACE: 'NAMESPACE',
} as const;
export type ApiResourceType = (typeof ApiResourceType)[keyof typeof ApiResourceType];

export function instanceOfApiResourceType(value: any): boolean {
  for (const key in ApiResourceType) {
    if (Object.prototype.hasOwnProperty.call(ApiResourceType, key)) {
      if (ApiResourceType[key as keyof typeof ApiResourceType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ApiResourceTypeFromJSON(json: any): ApiResourceType {
  return ApiResourceTypeFromJSONTyped(json, false);
}

export function ApiResourceTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiResourceType {
  return json as ApiResourceType;
}

export function ApiResourceTypeToJSON(value?: ApiResourceType | null): any {
  return value as any;
}

export function ApiResourceTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ApiResourceType {
  return value as ApiResourceType;
}
